// hooks/usePhotoColourAdjuster.js - Hook for managing photo color adjustments
import { useEffect } from 'react';
import { usePhotoEditorContext } from '../context/PhotoEditorContext';
import { applyFilters } from '../utils/photoEditor';

const usePhotoColourAdjuster = ({ values }) => {
  const {
    fileURL,
    previewCanvasRef,
    originalSizeCanvasRef,
    setAdjustments
  } = usePhotoEditorContext();

  // Update adjustments in context when values change
  useEffect(() => {
    if (!values) return;
    setAdjustments(values);
  }, [values, setAdjustments]);

  // Apply filters when values or fileURL changes
  useEffect(() => {
    if (!fileURL || !values) return;
    
    const previewCanvas = previewCanvasRef.current;
    const originalSizeCanvas = originalSizeCanvasRef.current;
    
    if (!previewCanvas || !originalSizeCanvas) return;
    
    const applyFiltersToCanvases = async () => {
      try {
        await applyFilters(
          [previewCanvas, originalSizeCanvas],
          fileURL,
          values
        );
      } catch (error) {
        console.error('Error applying filters:', error);
      }
    };
    
    applyFiltersToCanvases();
  }, [fileURL, values, previewCanvasRef, originalSizeCanvasRef]);

  return {
    adjustments: values
  };
};

export default usePhotoColourAdjuster;
